module.exports = __webpack_public_path__ + "static/stay-on-top-wins-3f5b4eda343b7ae2331913be6aafa9c1.mp4";